import { createFileRoute, Outlet } from '@tanstack/react-router';
import { TooltipProvider } from '@worldcoo/ui/components/tooltip';

export const Route = createFileRoute('/www/.internal')({
	head: () => ({
		meta: [{ name: 'robots', content: 'noindex, nofollow' }],
	}),
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<TooltipProvider>
			<Outlet />
		</TooltipProvider>
	);
}
